<script>
  import ProductImage from './ProductImage.svelte';
  export let imgSrc;
  export let useProductImage = false;
  export let imgAlt;
  export let border = true;
  export let shadow = false;
  export let fullheight = false;
  export let invert = false;
  export let cursorPointer = true;
</script>

<div class="card" class:border class:shadow class:invert class:pointer={cursorPointer} class:fullheight>
  {#if imgSrc}
    {#if useProductImage}
      <ProductImage src={imgSrc} alt={imgAlt} />
    {:else}
      <img src={imgSrc} alt={imgAlt} />
    {/if}
  {/if}
  <slot />
</div>

<style>
  .card {
    border: 1px solid #eee;
    border-radius: 2px;
    text-align: center;
    padding: 1.5rem;
    transition: box-shadow 0.1s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .card.pointer {
    cursor: pointer;
  }
  .border {
    border-bottom: 3px solid #fe5900;
  }
  .invert {
    border: 1px solid #000;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .fullheight {
    height: 100%;
  }
  .card:hover {
    box-shadow: 0 0.2rem 2rem rgba(0, 0, 0, 0.15);
  }
  .shadow {
    box-shadow: 0 0.2rem 2rem rgba(0, 0, 0, 0.15);
  }
</style>
